<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>Notice of Exhibiting at Beautyworld Japan Tokyo</h3>
      <br>

      <div class="news_image">
        <img src="/assets/img/bwj09_outline_cube_L_jp.jpg" alt="Beautyworld Japan Tokyo 2026">
      </div>

      <p>
      We will be exhibiting at Beautyworld Japan Tokyo.<br>
      You will be able to try our professional machine Dr-PRO MAX, released last year, as well as our retail beauty device Dr-PRO BEAUTY SECRET.<br>
      Please feel free to visit our booth.
      </p>

      <p>
       Date: May 18 (Mon) – May 20 (Wed), 2026<br>
       Time: 10:00 – 18:00 (Until 16:30 on the final day)<br>
       Venue: Tokyo Big Sight West Halls 1–4, South Halls 1–4 (3-11-1 Ariake, Koto-ku, Tokyo 135-0063, Japan)<br>
       Exhibitor: Scandinavia Service Co., Ltd.<br>
       Booth Number: W1-P033
<br>
      </p>

      <p class="reserve">
        Advance reservation here:
        <a
          href="https://docs.google.com/forms/d/19HladIstnD9spBqWrO-qk0ybv6Q1IZbRBHjLps_T4Vs/edit"
          target="_blank"
          rel="noopener"
        >
          Reservation Form
        </a>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news20260518',
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

.news_image {
  margin: 10px 0 25px;
}

.news_image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.reserve a {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>